import { memo } from "react";

export const Branding = memo(({ title }: { title: any }) => (
  <div className="Luthers-banner">
    <div className="text-on-banner">
      <h1 className="CC">{title}</h1>
    </div>
  </div>
));
